import { api } from './client'

/**
 * Prévia do gate de controle de mudança: esta ação, neste tenant, vai exigir
 * GMUD?
 *
 * Existe porque a tela precisa dizer ao operador o que o botão vai fazer ANTES
 * do clique. Desde 08/08/2026 o comitê é o interruptor do controle — a maioria
 * dos tenants não passa por GMUD —, e um wizard que promete "Enviar para GMUD"
 * a todos manda o operador esperar por uma aprovação que nunca vem.
 *
 * É prévia, não decisão: quem decide continua sendo o gate dentro da rota que
 * muta. A resposta pode envelhecer (basta cadastrarem um comitê no meio), e o
 * pior caso é um rótulo desatualizado — nunca uma mudança sem controle.
 */
/** Espelha `_CHANGE_CONTROL_PREVIEW` do api.py — um valor fora do mapa responde 422. */
export type ChangeControlActionKind = 'waf_provision' | 'waf_delete' | 'ztna_onboard'

export interface ChangeControlPreview {
  requires_gmud: boolean
  /** Por que exigiu, ou por que não: `organizacao_sem_comite`,
   *  `ambiente_fora_da_abrangencia` (o ambiente não está na lista da
   *  organização), `acao_critica`… Vai também para a auditoria no
   *  envio, e é o que responde "por que esta mudança não passou por GMUD?". */
  motivo: string
}

export function getChangeControlPreview(
  tenantId: number,
  actionKind: ChangeControlActionKind,
  /** Ambiente do RECURSO, quando ele tem um próprio (aplicação de ZTNA). */
  environment?: string,
): Promise<ChangeControlPreview> {
  return api
    .get<ChangeControlPreview>(`/v1/tenants/${tenantId}/change-control/preview`, {
      params: { action_kind: actionKind, ...(environment ? { environment } : {}) },
    })
    .then(r => r.data)
}
